import { render, staticRenderFns } from "./test-canvas.vue?vue&type=template&id=494b5f1e&scoped=true&"
import script from "./test-canvas.vue?vue&type=script&lang=js&"
export * from "./test-canvas.vue?vue&type=script&lang=js&"
import style0 from "./test-canvas.vue?vue&type=style&index=0&id=494b5f1e&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494b5f1e",
  null
  
)

export default component.exports